import instance from "../_http";

export default {
  /**
   * 添加
   * @param {*} website
   * @returns
   */
  add: (website) => {
    return instance.post("/api/ipms/attendance-manager/save", website);
  },
  /**
   *  删除
   */
  remove: (id) => {
    return instance.delete(`/api/ipms/attendance-manager/${id}`);
  },
  /**
   * 更新
   * @param {*} website
   * @returns
   */
  update: (website) => {
    return instance.put("/api/ipms/attendance-manager/update", website);
  },
  /**
   * 查询
   * @param {*} query
   * @returns
   */
  query: (query, page) => {
    return instance.get("/api/ipms/attendance-manager/query", {
      params: { ...query, page: page.page, size: page.size, sort: page.sort },
    });
  },
  /**
   * 详情
   * @param {*} id
   * @returns
   */
  detail: (id) => {
    return instance.get(`/api/ipms/attendance-manager/${id}`);
  },

  /**
   * 组管理员列表
   */
  treeselect: () => {
    return instance.get("/api/ipms/attendance-manager/treeselect");
  },
  /**
   * 组管理员列表
   */
   selectManagerAdd: () => {
    return instance.get("/api/ipms/attendance-manager/selectManagerAdd");
  },
};
